import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import notFound from '@app/images/content/notFound.jpg';
import '@app/scss/components/notFound.scss';

interface NotFoundProps {
	header?: string;
	replacePath?: boolean;
}

const NotFound: React.FC<NotFoundProps> = ({ header = 'Woof! Looks like this page doesn’t exist.', replacePath = true }) => {
	const navigate = useNavigate();
	const serverPage = useSelector((state: any) => state?.serverPage, shallowEqual);

	React.useEffect(() => {
		replacePath ? navigate('/not-found', { replace: true }) : null;

		if (serverPage?.page) {
			serverPage.page = null;
		}
	}, []);

	return (
		<div className="not-found">
			<div className="not-found__wrapper">
				<div className="not-found-inner">
					<h2>{header}</h2>
					<h6>Try searching our site or head back to our home page.</h6>
					<img src={notFound} alt="cat-and-dog" />
					<button className="btn btn-md btn-primary" onClick={() => navigate(-1)}>
						Back to previous page
					</button>
				</div>
			</div>
		</div>
	);
};

export default NotFound;
